export default "__VITE_ASSET__DYqGk35t__"